import * as React from 'react'

import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-theme'
import { PictureProps } from '@thg-commerce/gravity-system'
import { withPrefetch } from '@thg-commerce/gravity-system/prefetch'

import {
  LogoPictureContainer,
  LogoText,
  StyledLink,
  StyledPicture,
} from './styles'

export interface LogoProps {
  widgetIndex: number
  picture?: PictureProps
  horizontalAlignment?: HorizontalAlignment
  link?: string
  title?: string
  brandName?: string
  textOnlyCarousel?: boolean
}

const PrefetchStyledLink = withPrefetch('href', StyledLink)

// Helper functions
const getDisplayText = (props: LogoProps) =>
  props.brandName || props.picture?.alt || props.title || ''

const hasValidImage = (picture?: PictureProps) =>
  picture?.default && picture.default.trim() !== ''

const getAriaLabel = (props: LogoProps) =>
  props?.brandName || props.picture?.alt || props.title || ''

export const BrandTextLogo = (props: LogoProps) => {
  const theme = useTheme()

  const displayText =
    props.brandName || props.title || props.picture?.alt || 'Brand'

  const content = (
    <LogoPictureContainer
      data-testid="logo-text-container"
      textOnlyCarousel={props.textOnlyCarousel}
    >
      <LogoText horizontalAlignment={props.horizontalAlignment} theme={theme}>
        {displayText}
      </LogoText>
    </LogoPictureContainer>
  )

  return props?.link ? (
    <PrefetchStyledLink aria-label={props?.brandName || ''} href={props.link}>
      {content}
    </PrefetchStyledLink>
  ) : (
    content
  )
}

export const LogoPicture = (props: LogoProps) => {
  const displayText = getDisplayText(props)
  const hasImage = hasValidImage(props.picture)

  if (props.textOnlyCarousel) {
    return <BrandTextLogo {...props} brandName={displayText} />
  }

  if (!hasImage && props.brandName) {
    return <BrandTextLogo {...props} />
  }

  const picture = (
    <LogoPictureContainer data-testid="logo-picture-container">
      {props.picture?.default && (
        <StyledPicture
          aspectRatio={'1/1 auto'}
          lazy={props.widgetIndex > 1}
          {...props.picture}
          alt={getDisplayText(props)}
        />
      )}
      {props?.title && (
        <LogoText horizontalAlignment={props.horizontalAlignment}>
          {props.title}
        </LogoText>
      )}
    </LogoPictureContainer>
  )

  return props?.link ? (
    <PrefetchStyledLink aria-label={getAriaLabel(props)} href={props.link}>
      {picture}
    </PrefetchStyledLink>
  ) : (
    picture
  )
}
